var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountStorageHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขข้อมูลรอบนับสต๊อก","link_back":"stock/count_warehouse/countlistwarehouse"}}),_c('Warehouse_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }